import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({
  name: 'FeatureItems',
})(({ brandColors, spacing, breakpoints, typography }) => ({
  features: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(0),
  },
  featureContainer: {
    display: 'flex',
    flexDirection: 'row',
    color: brandColors.black,
    '&.darkMode': {
      color: brandColors.white,
    },
  },
  featureIcon: {
    display: 'flex',
    alignItems: 'center',
    width: typography.pxToRem(24),
    height: typography.pxToRem(24),
    marginRight: spacing(0),
    [breakpoints.up('sm')]: {
      marginRight: spacing(1),
    },
  },
}));

export default useStyles;
